import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-[#FFF8F0] text-[#3D2B1F] px-4" data-id="element-54">
      <div className="max-w-4xl mx-auto" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2rem] p-8 md:p-16 border border-green-400/30 shadow-xl text-center relative overflow-hidden" data-id="element-56">
          {/* Decorative shield background */}
          <ShieldCheckIcon className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] text-green-500/5 pointer-events-none" data-id="element-57" />

          <div className="relative z-10" data-id="element-58">
            <div className="inline-flex items-center justify-center p-6 bg-green-50 rounded-full mb-8 border border-green-200" data-id="element-59">
              <ShieldCheckIcon className="w-16 h-16 text-green-500" data-id="element-60" />
            </div>

            <h2 className="text-4xl md:text-5xl font-black mb-8 text-[#3D2B1F]" data-id="element-61">
              Garantía Total de 45 Días
            </h2>

            <p className="text-xl md:text-2xl text-[#6B5344] leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-62">
              Si por cualquier motivo sentís que este libro no cumplió tus
              expectativas, simplemente pedís el reembolso y te devolvemos el
              dinero.
            </p>

            <div className="mt-10 inline-block bg-green-50 px-8 py-4 rounded-full border border-green-200" data-id="element-63">
              <span className="text-2xl font-bold text-green-600 uppercase tracking-widest" data-id="element-64">
                Sin preguntas.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}